import React, { useState } from "react";
import useRequest from "../../../../utils/useRequest";
import {
    getLoginAbnormalStudentList,
    LoginAbnormalItem
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import { AsideIp } from "./components/AsideIp";
import { ColumnProps } from "antd/lib/table/interface";

export function AbnormalLogin() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getLoginAbnormalStudentList(examId, studentName),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<LoginAbnormalItem>[] = [
        {
            title: "登录次数",
            dataIndex: "loginNum"
        }
    ];

    return (
        <InvigilationProvider
            examId={examId}
            setExamId={setExamId}
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}>
            <Layout
                refresh={refresh}
                title="多次登录监测"
                table={
                    <StuTable
                        onErrChange={refresh}
                        dataSource={data?.dataList || []}
                        loading={loading}
                        columns={columns}
                        buttonShow={[true, false, true, true]}
                    />
                }
                aside={<AsideIp examId={examId} />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
